<template>
  <div v-if="loading" class="generic-loader-wrapper" :style="{ padding: this.getPaddingValue+'px' }">
    <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px" height="60" viewBox="0 0 100 100" enable-background="new 0 0 0 0"
         xml:space="preserve">
      <path class="fill-current text-primary"
            d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
        <animateTransform attributeName="transform" attributeType="XML" type="rotate"
                          dur="1s"
                          from="0 50 50" to="360 50 50" repeatCount="indefinite"/>
      </path>
    </svg>
  </div>
  <div v-else>
    <slot/>
  </div>
</template>

<script type="application/javascript">
export default {
  props: [
    /**
     * Whether the content is still loading. Can be of any type and will be converted to boolean
     */
    "loading",

    /**
     * Optional. Whether to padd the loader (NOT the content). When omitted, there is no padding.
     * When a number, the loader is padded by that many pixels. when trueish and not a number,
     * will default to 16.
     */
    "padded"
  ],

  computed: {
    getPaddingValue() {
      if (!this.padded) return 0;
      else if (isNaN(this.padded)) return 16;
      else return this.padded;
    }
  }
}
</script>
<style>
.generic-loader-wrapper {
  min-height: 50px;
  width: 100%;
  height: 100%;
  text-align: center;
  position: relative;
}
.generic-loader-wrapper svg {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>